var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "tr",
    {
      class: {
        resolved: _vm.clarification.answer,
        "direct-message": _vm.isDirectMessage,
        "border border-primary": _vm.selected,
      },
    },
    [
      _c("td", { staticClass: "column-info text-center align-middle" }, [
        "assignment_alias" in _vm.clarification &&
        _vm.clarification.assignment_alias
          ? _c("span", [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.T.clarificationHomework)),
              ]),
              _vm._v(" " + _vm._s(_vm.clarification.assignment_alias) + " "),
            ])
          : _vm._e(),
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v(
            _vm._s(
              "contest_alias" in _vm.clarification &&
                _vm.clarification.contest_alias
                ? _vm.T.clarificationContest
                : _vm.T.clarificationProblem
            )
          ),
        ]),
        _vm._v(
          " " +
            _vm._s(
              "contest_alias" in _vm.clarification &&
                _vm.clarification.contest_alias
                ? _vm.clarification.contest_alias
                : _vm.clarification.problem_alias
            ) +
            " "
        ),
        _c("span", { attrs: { "data-author": "" } }, [
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.T.clarificationsAskedBy)),
          ]),
          _vm._v(" " + _vm._s(_vm.clarificationAuthorReceiver) + " "),
        ]),
        _c("span", { staticClass: "font-weight-bold" }, [
          _vm._v(_vm._s(_vm.T.clarificationTime)),
        ]),
        _vm._v(
          " " + _vm._s(_vm.time.formatDateTime(_vm.clarification.time)) + " "
        ),
      ]),
      _c(
        "td",
        {
          staticClass: "column-message align-middle",
          attrs: { "data-form-clarification-message": "" },
        },
        [
          _c("span", { staticClass: "text-monospace text-dark" }, [
            _vm._v(_vm._s(_vm.clarification.message)),
          ]),
        ]
      ),
      _vm.isAdmin
        ? _c(
            "td",
            {
              staticClass: "column-answer align-middle",
              attrs: { "data-form-clarification-resolved-answer": "" },
            },
            [
              _vm.clarification.answer
                ? [
                    _c("span", { staticClass: "text-monospace text-dark" }, [
                      _vm._v(_vm._s(_vm.clarification.answer)),
                    ]),
                    !_vm.showUpdateAnswer
                      ? _c("div", { staticClass: "form-check mt-2 mt-xl-0" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.showUpdateAnswer,
                                  expression: "showUpdateAnswer",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.showUpdateAnswer)
                                  ? _vm._i(_vm.showUpdateAnswer, null) > -1
                                  : _vm.showUpdateAnswer,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.showUpdateAnswer,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.showUpdateAnswer = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.showUpdateAnswer = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.showUpdateAnswer = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.T.clarificationUpdateAnswer) +
                                " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              !_vm.clarification.answer || _vm.showUpdateAnswer
                ? _c(
                    "form",
                    {
                      staticClass: "form-inline justify-content-between",
                      attrs: { "data-form-clarification-answer": "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.sendClarificationResponse.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "form-group mb-0" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedResponse,
                                expression: "selectedResponse",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { "data-select-answer": "" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedResponse = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.responses, function (response) {
                            return _c(
                              "option",
                              {
                                key: response.value,
                                domProps: { value: response.value },
                              },
                              [_vm._v(" " + _vm._s(response.text) + " ")]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm.selectedResponse === "other"
                        ? _c("div", { staticClass: "form-group mt-1 mb-0" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.message,
                                  expression: "message",
                                },
                              ],
                              attrs: { placeholder: _vm.T.wordsAnswer },
                              domProps: { value: _vm.message },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.message = $event.target.value
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between w-100" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-check mt-2 mt-xl-0" },
                            [
                              _c("label", { staticClass: "form-check-label" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.isPublic,
                                      expression: "isPublic",
                                    },
                                  ],
                                  staticClass: "form-check-input",
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.isPublic)
                                      ? _vm._i(_vm.isPublic, null) > -1
                                      : _vm.isPublic,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.isPublic,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.isPublic = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.isPublic = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.isPublic = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" " + _vm._s(_vm.T.wordsPublic) + " "),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm mt-2",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(" " + _vm._s(_vm.T.wordsSend) + " ")]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _c(
            "td",
            {
              staticClass: "column-answer align-middle",
              attrs: { "data-clarification-answer-text": "" },
            },
            [
              _vm.clarification.answer
                ? _c("span", { staticClass: "text-monospace text-dark" }, [
                    _vm._v(_vm._s(_vm.clarification.answer)),
                  ])
                : _vm._e(),
            ]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }